/* eslint-disable import/prefer-default-export */

export const notificationTypes = {
  bluetoothOff: 'bluetoothOff',
  bluetoothUnsupported: 'bluetoothUnsupported',
  bluetoothUnauthorized: 'bluetoothUnauthorized',
  error: 'error',
  tLabelDownloadComplete: 'tLabelDownloadComplete',
};

export function createNotification(
  message,
  type,
  params,
  isError = false,
  persistent = false,
  hideForRoutes = [],
) {
  return {
    message,
    action: { type, params },
    isError,
    persistent,
    hideForRoutes,
  };
}
